// ########################################################
/*
 * Email API functions for Gmail and Outlook.
 * 
 * Routes conditionally based on `isOutlook` flag.
 * Handles reply, forward, and send using same params.
 * Uses `fetchWithHandling` for error-safe API calls.
 */

import { API_URL, fetchWithHandling } from "./api"

// Function to get sessions by bot and user
export const getAuthenticatedApps = async (messageId, accessToken) => {

  return fetchWithHandling(`${API_URL}/gmail_emails/emails/${messageId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
  });
};

// forward and an Email to a list of recepients
export const forwardEmail = async (accessToken, forwardData, isOutlook = true) => {
  const endpoint = isOutlook ? "/outlook_mails/forward" : "/gmail_emails/forward";
  const url = new URL(`${API_URL}${endpoint}`);
  return fetchWithHandling(url.toString(), {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(forwardData),
  });
};

export const replyToEmail = async (accessToken, formData, isOutlook = true) => {
  const endpoint = isOutlook ? "/outlook_mails/reply" : "/gmail_emails/reply";
  const url = new URL(`${API_URL}${endpoint}`);
  return fetchWithHandling(url.toString(), {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
    body: formData,
  });
};

//generate a draft reply using ai
export const draftReplyEmail = async (accessToken, messageId, customPrompt = null, isOutlook = true) => {
  const endpoint = isOutlook ? "/outlook_mails/draft_reply/" : "/gmail_emails/draft_reply/";
  const url = new URL(`${API_URL}${endpoint}${messageId}`);

  if (customPrompt) {
    url.searchParams.append("custom_prompt", customPrompt);
  }

  return fetchWithHandling(url.toString(), {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};

// compose an Email
export const draftEmail = async (accessToken, body, isOutlook = true) => {
  const endpoint = isOutlook ? "/outlook_mails/draft_email" : "/gmail_emails/draft_email";
  const url = new URL(`${API_URL}${endpoint}`);

  return fetchWithHandling(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${accessToken}`,

      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
};

// Function to get the list of emails after searching
export const searchEmails = async (accessToken, searchQuery = '', filterConditions = '', page = 1, pageSize = 10, isOutlook = true) => {
  // Determine the API endpoint based on email type
  const endpoint = isOutlook ? "/outlook_mails/search_emails" : "/gmail_emails/search_emails";
  const url = new URL(`${API_URL}${endpoint}`);

  // Append required query parameters
  if (searchQuery) {
    url.searchParams.append("search_query", searchQuery);
  }
  if (isOutlook && filterConditions) {
    url.searchParams.append("filter_conditions", filterConditions);
  }
  url.searchParams.append("page", page);
  url.searchParams.append("page_size", pageSize);

  return fetchWithHandling(url.toString(), {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};

// send an email
export const sendEmail = async (accessToken, formData, isOutlook = true) => {
  const endpoint = isOutlook ? "/outlook_mails/send" : "/gmail_emails/send";
  const url = new URL(`${API_URL}${endpoint}`);

  return fetchWithHandling(url, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });
};